import React, { useState, useEffect, useRef } from 'react';
import HawaiiMapLoader from "@didi/hawaii-map-loader";
import type { HawaiiMapApi, HawaiiMapPlugin } from "@didi/hawaii-map-loader"
import { cloneDeep, debounce, isEmpty } from 'lodash';

import { Spin, message } from 'antd';

type PropsType = {
  value?: any;
  plugins?: any;
  onChange?: any;
  polygons: any;
  extraPolygons?: any;
  onPolygonChange?: any;
  type?: any;
  position?: any;
};

const SPMapFence: React.FC<PropsType> = (props) => {
  const { plugins, polygons = [], onPolygonChange, type, position, extraPolygons } = props;
  const mapContainerRef = useRef<HTMLDivElement>(null);

  const shapeRef = useRef<any>(null)

  const [showStartDraw, setShowStartDraw] = useState(false);

  const [loadingMap, setLoadingMap] = useState<boolean>(true);

  const handleStartDraw = () => {

    const points = shapeRef?.current?.getSelectedPoints() || [];
    if (points.length) {
      message.warning('已有绘制区域，请继续绘制或编辑区域')
    } else {
      shapeRef?.current?.edit("Polygon", false, []);
    }
  }

  useEffect(() => {
    HawaiiMapLoader
    .load({
      appKey: "car-rental",
      plugins: plugins || [],
    })
    .then(({ style, hawaiiMapApi, hawaiiMapPlugin }) => {
      if (!hawaiiMapApi) {
        return
      }
      // 初始化地图实例
      const map = new hawaiiMapApi.Map({
        container: mapContainerRef.current!, // 容器ID
        style: style
      })


      // map on load 事件完成后：此时可以往地图上添加图层
      map.on("load", () => {
        setLoadingMap(false);
        if (type === 'view') {
          let bounds: HawaiiMapApi.LngLatBounds | undefined = undefined;
          (polygons || []).forEach((item: any) => {
            if (!item.length) return;
            const polygon = new hawaiiMapApi.Polygon({
              map: map,
              path: item,
              strokeColor: '#FF33FF',
              strokeOpacity: 1,
              strokeWeight: 3,
              fillColor: '#1791fc',
              fillOpacity: 0.4,
              height: 100,
              extrusionHeight: 100,
              strokeStyle: 'solid',
              strokeDasharray: [10, 10],
              userData: {
               name: 'polygon'
              }
            });
            polygon.show();
            if (bounds) {
              bounds.extend(polygon.getBounds())
            } else {
              bounds = polygon.getBounds()
            }
          });
          if ((polygons || []).length) {
            bounds && map.fitBounds(bounds, { maxDuration: 0.1, padding: 100 });
          } else if (!polygons?.length && position) {
            map.jumpTo({ center: position });
          }
          return;
        };
        if (hawaiiMapPlugin.ShapeEdit) {
          const shapeEdit = new hawaiiMapPlugin.ShapeEdit(map);
          shapeEdit.on("change", debounce((latlngs: any) => {
            onPolygonChange(cloneDeep(latlngs));
          }, 200));

          shapeEdit.edit("Polygon", false, polygons[0]);
          const theOnlyPolygon = polygons[0];
          if (theOnlyPolygon || extraPolygons?.length) {
            const bounds = new hawaiiMapApi.LngLatBounds();
            
            theOnlyPolygon?.forEach((point: any) => {
              bounds.extend(point);
            });
            
            (extraPolygons || []).forEach((item: any) => {
              if (!item.length) return;
              const polygon = new hawaiiMapApi.Polygon({
                map: map,
                path: item,
                strokeColor: '#FF33FF',
                strokeOpacity: 1,
                strokeWeight: 3,
                fillColor: '#1791fc',
                fillOpacity: 0.4,
                height: 100,
                extrusionHeight: 100,
                strokeStyle: 'solid',
                strokeDasharray: [10, 10],
                userData: {
                 name: 'polygon'
                }
              });
              polygon.show();
              if (bounds) {
                bounds.extend(polygon.getBounds())
              }
            });
            !isEmpty(bounds) && map.fitBounds(bounds, { maxDuration: 0.1, padding: 120 });
          } else if (!polygons?.length && position) {
            map.jumpTo({ center: position });
          }
          shapeRef.current = shapeEdit;
        }
        map.on("dblclick", (abc: any) => {
          const selectedPoints = shapeRef.current?.getSelectedPoints();
          if (!selectedPoints?.length) {
            setShowStartDraw(true);
          }
        })
      });
    });
  }, []);

  return (
    <Spin size="large" spinning={loadingMap}>
      <div style={{ position: 'relative' }}>
        {showStartDraw && <div style={{ position: 'absolute', right: 10, top: 10, zIndex: 1, cursor: 'pointer', color: 'rgb(255, 100, 0)' }} onClick={handleStartDraw}>开始绘制</div>}
        <div ref={mapContainerRef} style={{ height: '65vh' }}></div>
      </div>
    </Spin>
  )
}

export default SPMapFence;
